<div>
  @if (locked()) {
    <p class="text-muted small fst-italic mb-2" data-testid="ppj-budget-locked-note">{{ lockedNote }}</p>
  }
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="row g-3 mb-2">
      <div class="col-6">
        <label for="ppj-budget-bonus-pot">Bonus Pot</label>
        <div class="input-group">
          <span class="input-group-text">$</span>
          <input
            id="ppj-budget-bonus-pot"
            type="text"
            inputmode="decimal"
            placeholder="0.00"
            class="form-control text-end"
            formControlName="bonusPot"
            data-testid="ppj-budget-bonus-pot-input"
            (blur)="onBonusPotBlur()"
          />
        </div>
      </div>
      <div class="col-6">
        <label for="ppj-budget-percent">Budgeted Labor</label>
        <div class="input-group">
          <input
            id="ppj-budget-percent"
            type="text"
            class="form-control"
            formControlName="budgetedLaborPercent"
            data-testid="ppj-budget-percent-input"
          />
          <span class="input-group-text">%</span>
        </div>
      </div>
    </div>
    @if (errorMessage()) {
      <p class="text-danger" data-testid="ppj-budget-error">{{ errorMessage() }}</p>
    }
    <button
      type="submit"
      class="btn btn-primary btn-sm mt-3"
      [disabled]="saving() || locked() || !canEdit()"
    >
      Save
    </button>
  </form>
</div>
